import {makeObservable} from 'mobx';

import type {EventApiModel} from '../../../api/event';
import type {Nullable, Subset} from '../../../utils/utility-types';
import type {ConferenceModel} from '../Conference/Conference.model';
import type {TaskModel} from '../Task/Task.model';
import type {UserModel} from '../User/User.model';

import {BaseModel} from '../Base/Base.model';

const ModelName = 'AppEventModel';

export class AppEventModel extends BaseModel {
  actor: UserModel;
  context: Nullable<AppEventModel.Context>;
  type: AppEventModel.SupportedType;
  user: UserModel;

  constructor(props: AppEventModel.Props) {
    super(props);
    Object.assign(this, props);

    makeObservable(
      this,
      BaseModel.mobxAnnotationFactory<AppEventModel, AppEventModel.Props>(
        props,
      ),
    );
  }

  static override get modelName(): typeof ModelName {
    return ModelName;
  }

  get modelName(): typeof ModelName {
    return ModelName;
  }
}

export namespace AppEventModel {
  export type Context = ConferenceModel | TaskModel;

  export type Props = BaseModel.ModelToProps<AppEventModel>;

  export type SupportedSocketType =
    | 'coach_coverage_course_started'
    | 'coach_coverage_course_stopped'
    | 'file_converted'
    | 'membership_frozen'
    | 'membership_unfrozen'
    | 'post_created'
    | 'post_deleted'
    | 'post_updated'
    | SupportedType;

  export type SupportedType = Subset<
    EventApiModel['type'],
    | 'coach_coverage'
    | 'conference_client_joined'
    | 'conference_started'
    | 'conference_stopped'
    | 'conference_stopped_automatically'
    | 'course_started'
    | 'course_stopped'
    | 'membership_created'
    | 'task_done'
  >;
}
